import { useTheme } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import React from 'react';

export const PageLoading: React.FC = () => {
  const { colors } = useTheme();
  return (
    <>
      <Grid
        container
        sx={{
          alignContent: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress size="80px" sx={{ color: colors.scarletRed }} />
      </Grid>
    </>
  );
};
